import { useMediaQuery, useTheme } from '@mui/material';

// Default MUI breakpoints
// xs, extra-small: 0px
// sm, small: 600px
// md, medium: 900px
// lg, large: 1200px
// xl, extra-large: 1536px

export function useIsMobile() {
	const theme = useTheme();
	return useMediaQuery(theme.breakpoints.down('sm'));
}

export const BREAKPOINT_DESKTOP_SMALL = 'sm';
export function useIsDesktop() {
	const theme = useTheme();
	return useMediaQuery(theme.breakpoints.up(BREAKPOINT_DESKTOP_SMALL));
}

export const BREAKPOINT_DESKTOP_MEDIUM = 'md';
export function useIsDesktopSmall() {
	const theme = useTheme();
	return useMediaQuery(theme.breakpoints.down(BREAKPOINT_DESKTOP_MEDIUM));
}
